import React from "react";
import { motion } from "framer-motion";
import { Eye, Target, HeartHandshake, Lightbulb } from "lucide-react";
const MissionVision = () => {
  const cards = [
    {
      icon: <Target size={32} />,
      title: "Our Mission",
      desc: "To provide quality higher education and guide students toward academic excellence, discipline, and personal growth.",
    },
    {
      icon: <Eye size={32} />,
      title: "Our Vision",
      desc: "To become a trusted institution that empowers students with knowledge, values, and confidence for a successful future.",
    },
    {
      icon: <HeartHandshake size={32} />,
      title: "Our Values",
      desc: "We believe in discipline, honesty, respect, dedication, and an education system focused on overall development.",
    },
  ];
  const points = [
    {
      number: "01",
      title: "Quality Learning",
      text: "Focused academic environment for students.",
    },
    {
      number: "02",
      title: "Moral Education",
      text: "Discipline and values in daily learning.",
    },
    {
      number: "03",
      title: "Future Growth",
      text: "Guidance for confidence and career goals.",
    },
  ];
  return (
    <section className="w-full bg-white py-12 md:py-16 overflow-hidden">
      <div className="w-full px-6 lg:px-12">
        <div className="max-w-7xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 25 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="text-center max-w-3xl mx-auto mb-10"
          >
            <span className="inline-flex items-center gap-2 bg-[#071A52] text-[#FFD700] px-5 py-2 rounded-full text-xs font-black uppercase tracking-wide mb-4 shadow">
              <Lightbulb size={15} />
              Our Purpose
            </span>
            <h2 className="text-3xl md:text-4xl font-black text-[#071A52] leading-tight">
              Our Mission, Vision & Values
            </h2>
            <div className="w-24 h-1.5 bg-[#FFD700] rounded-full mx-auto mt-4 mb-4"></div>
            <p className="text-gray-600 text-sm md:text-base leading-relaxed">
              We aim to create a strong academic environment where students learn
              with discipline, confidence, and moral responsibility.
            </p>
          </motion.div>
          <div className="grid md:grid-cols-3 gap-6">
            {cards.map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 35 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.55, delay: index * 0.12 }}
                viewport={{ once: true }}
                className="group relative bg-[#F6F8FC] rounded-[28px] p-7 border border-gray-100 shadow-md hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 overflow-hidden"
              >
                <div className="absolute top-0 right-0 w-28 h-28 bg-[#FFD700]/20 rounded-bl-full"></div>

                <div className="relative z-10">
                  <div className="w-16 h-16 rounded-2xl bg-[#071A52] text-[#FFD700] flex items-center justify-center shadow-lg mb-6 group-hover:bg-[#FFD700] group-hover:text-[#071A52] transition-all duration-300">
                    {item.icon}
                  </div>

                  <h3 className="text-xl font-black text-[#071A52] mb-3">
                    {item.title}
                  </h3>

                  <p className="text-gray-600 text-sm leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </motion.div>
            ))}
          </div>
          <motion.div
            initial={{ opacity: 0, y: 25 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="mt-10 bg-gradient-to-r from-[#071A52] via-[#0B1F5C] to-[#102B75] rounded-[30px] overflow-hidden shadow-xl"
          >
            <div className="grid md:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-white/20">
              {points.map((item, index) => (
                <div key={index} className="p-6 md:p-8">
                  <span className="text-[#FFD700] text-3xl font-black">
                    {item.number}
                  </span>
                  <h3 className="text-white text-xl font-black mt-3 mb-2">
                    {item.title}
                  </h3>
                  <p className="text-white/75 text-sm leading-relaxed">
                    {item.text}
                  </p>
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
export default MissionVision;